import { IErrorResponse, ISubError } from "../api/models";

export const returnError = (error: IErrorResponse) => {
  const errors = error?.subErrors?.map((subError: ISubError) => {
    return `${subError?.field} ${subError?.message}`;
  });
  return errors.toString();
};
